import { ApiError, isExpectedClientApiError } from './api-error';

const EXPECTED_QUERY_ERROR_MESSAGES = new Set([
  'WORKFLOW_WRONG_ORG',
  'EXECUTION_WRONG_ORG',
  'TEST_RUN_WRONG_ORG',
  'ISSUE_WRONG_ORG',
]);

const TRANSIENT_FETCH_ERROR_MESSAGES = new Set([
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource.',
]);

export function isTransientFetchTransportError(error: unknown): boolean {
  if (!(error instanceof TypeError)) return false;
  if (TRANSIENT_FETCH_ERROR_MESSAGES.has(error.message)) return true;
  return /^Failed to fetch \([^)]+\)$/.test(error.message);
}

export function shouldSuppressQuerySentry(error: unknown): boolean {
  if (isExpectedClientApiError(error)) {
    return true;
  }

  return (
    error instanceof Error &&
    (EXPECTED_QUERY_ERROR_MESSAGES.has(error.message) || isTransientFetchTransportError(error))
  );
}

export function isExpectedEmailAuthError(error: unknown): boolean {
  if (!(error instanceof Error) || error.name !== 'EmailAuthError') {
    return false;
  }

  if (!('code' in error)) {
    return false;
  }

  const code = error.code;
  return typeof code === 'string' && code.length > 0;
}

export function shouldSuppressMutationSentry(error: unknown): boolean {
  if (isExpectedEmailAuthError(error)) return true;
  if (error instanceof ApiError && (error.userError || error.status === 403)) return true;
  return isTransientFetchTransportError(error);
}
